import { memo, useCallback, type ChangeEvent, type FC } from "react";
import StyledTextInput from "src/components/reusable/StyledTextInput";
import CampaignFormField from "./CampaignFormField";
import { getFieldErrorId, useRequiredFieldError } from "./UseRequiredFieldError";

interface CampaignTextFieldProps {
  id: string;
  label: string;
  value: string;
  onChange?: (_value: string) => void;
  placeholder?: string;
  required?: boolean;
  hint?: string;
  disabled?: boolean;
  type?: string;
  maxLength?: number;
  helperText?: string;
}

const CampaignTextField: FC<CampaignTextFieldProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  required = false,
  hint,
  disabled = false,
  type,
  maxLength,
  helperText,
}) => {
  const { hasError, handleBlur } = useRequiredFieldError(value, required && !disabled);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => onChange?.(event.target.value),
    [onChange]
  );

  return (
    <CampaignFormField
      label={label}
      htmlFor={id}
      required={required}
      hint={hint}
      hasError={hasError}
      helperText={helperText}
    >
      <StyledTextInput
        id={id}
        type={type}
        maxLength={maxLength}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        aria-invalid={hasError}
        aria-describedby={hasError ? getFieldErrorId(id) : undefined}
        className="campaign-flow__input"
      />
    </CampaignFormField>
  );
};

export default memo(CampaignTextField);
